import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmDialogComponent } from './confirm-dialog.component';
// import { TAPConfirmDialogComponent } from './confirm-dialog.tap.component';
import { LoadingModule } from '@ibe.components/shared/loading/loading.module';
import { INDRAConfirmDialogComponent } from './confirm-dialog.indra.component';

@NgModule({
	imports: [CommonModule, LoadingModule],
	declarations: [
		ConfirmDialogComponent, 
		INDRAConfirmDialogComponent
		// TAPConfirmDialogComponent
	],
	exports: [
		// TAPConfirmDialogComponent, 
		INDRAConfirmDialogComponent,
		LoadingModule]
})
export class ConfirmDialogModule {}
